import React from "react"
import SliderWrapper from "./SliderWrapper"

const GridWrapper = ({ className, children, _uid }) => {
  return (
    <>
      <div
        className={`hidden lg:flex lg:flex-row lg:flex-wrap -mx-grid -mb-8 ${
          className?.length > 0 ? className : ""
        }`}
      >
        {children}
      </div>
      <SliderWrapper
        _uid={_uid}
        className={`block lg:hidden ${className?.length > 0 ? className : ""}`}
      >
        {children}
      </SliderWrapper>
    </>
  )
}

export default GridWrapper
